import { useFeatures } from '@/contexts/root-store-context'
import { observer } from 'mobx-react-lite'
import { lazy } from 'react'

const Inner = lazy(() => import('./Inner'))

/**
 * Host component for all job-related dialogs.
 * Uses lazy loading to defer loading the dialogs until the jobs feature
 * is actually requested, improving initial bundle size.
 */
export const JobDialogsHost = observer(function JobDialogsHost() {
  const { isJobsRequested } = useFeatures(({ jobs }) => ({
    isJobsRequested: jobs.internal.isRequested,
  }))

  if (!isJobsRequested()) {
    return null
  }

  return <Inner />
})
